/*
  Eigene Messung der Ladewerte (Core Web Vitals) bei echten Besuchern.
  ===================================================================

  Warum: Google veroeffentlicht seine Zahlen als 28-Tage-Durchschnitt mit
  mehreren Tagen Verzug. Nach einer Aenderung sieht man dort erst nach
  Wochen, ob sie gewirkt hat. Diese Messung liefert die Werte derselben
  Besucher innerhalb weniger Stunden - und zusaetzlich getrennt nach
  Erstbesuch und Wiederkehr. Genau darauf kam es hier an: der
  Schriftwechsel-Sprung trifft ausschliesslich Erstbesucher.

  Datenschutz:
  - Es werden KEINE personenbezogenen Daten erhoben. Gemessen werden nur
    Zahlen ueber den Seitenaufbau (Verschiebung, Ladezeit in Millisekunden).
  - Es wird KEIN eigenes Cookie gesetzt und KEINE Verbindung zu einem
    fremden Server aufgebaut. Der Code steht komplett in dieser Datei im
    eigenen Shop, es wird nichts nachgeladen.
  - Gesendet wird ausschliesslich ueber das bereits vorhandene Google
    Analytics. Ist Analytics nicht aktiv - etwa weil der Besucher im
    Cookie-Banner abgelehnt hat - wird nichts gesendet (Pruefung unten:
    `typeof gtag !== 'function'`).
  - Der Merker fuer Erst-/Wiederbesuch liegt in localStorage. Das ist kein
    Cookie, verlaesst das Geraet nie und enthaelt nur den Wert "1".
    Wer das nicht moechte, setzt MERKER_NUTZEN unten auf false; dann faellt
    nur die Unterscheidung Erstbesuch/Wiederkehr weg.

  Gemessen werden alle drei Core Web Vitals - CLS (Springen des Layouts),
  LCP (wann der groesste Inhalt steht), INP (Reaktion auf Klicks) - sowie
  zusaetzlich FCP (erster sichtbarer Inhalt) und TTFB (Antwortzeit des
  Servers). Die beiden letzten helfen einzuordnen, woran es liegt, wenn
  LCP schlecht ist.
*/

(function () {
  'use strict';

  var MERKER_NUTZEN = true;

  if (!('PerformanceObserver' in window)) return;

  var clsWert = 0;
  var fenster = [];   // laufendes Sitzungsfenster
  var lcpWert = 0;
  var inpWert = 0;
  var fcpWert = 0;
  var gesendet = false;

  // --- Im Hintergrund geoeffnet? ----------------------------------------
  // Oeffnet jemand die Seite in einem Hintergrund-Tab (Mittelklick, Link aus
  // einer App, wiederhergestellte Tabs), malt der Browser erst, wenn man
  // hinwechselt. Gemessen wird dann die Wartezeit des Besuchers, nicht die
  // der Seite. In den Daten vom 23.-25.09.2026 gab es dadurch eine Gruppe
  // mit 48 Aufrufen und im Schnitt 9,8 s "Ladezeit", die alle Durchschnitte
  // verzerrt hat. Google laesst solche Aufrufe bei den Ladezeiten weg -
  // seit 26.09.2026 tun wir das auch.
  var imHintergrundGestartet = document.visibilityState === 'hidden';

  function warVorErstemBildVersteckt() {
    if (imHintergrundGestartet) return true;
    try {
      // Chrome fuehrt Buch ueber jeden Sichtbarkeitswechsel seit Seitenstart
      var wechsel = performance.getEntriesByType('visibility-state') || [];
      for (var i = 0; i < wechsel.length; i++) {
        if (wechsel[i].name === 'hidden' && (!fcpWert || wechsel[i].startTime < fcpWert)) return true;
      }
    } catch (e) { /* aeltere Browser: nur der Startzustand zaehlt */ }
    return false;
  }

  // --- CLS nach Googles Verfahren ---------------------------------------
  // Nicht alle Verschiebungen werden addiert, sondern es zaehlt das
  // schlimmste "Sitzungsfenster": hoechstens 5 Sekunden lang, und eine
  // Pause von mehr als 1 Sekunde beginnt ein neues Fenster.
  try {
    new PerformanceObserver(function (liste) {
      liste.getEntries().forEach(function (eintrag) {
        if (eintrag.hadRecentInput) return;   // vom Nutzer ausgeloest -> zaehlt nicht

        var erste = fenster[0];
        var letzte = fenster[fenster.length - 1];

        if (fenster.length &&
            eintrag.startTime - letzte.startTime < 1000 &&
            eintrag.startTime - erste.startTime < 5000) {
          fenster.push(eintrag);
        } else {
          fenster = [eintrag];
        }

        var summe = 0;
        for (var i = 0; i < fenster.length; i++) summe += fenster[i].value;
        if (summe > clsWert) clsWert = summe;
      });
    }).observe({ type: 'layout-shift', buffered: true });
  } catch (e) { /* Browser kennt layout-shift nicht */ }

  // --- LCP --------------------------------------------------------------
  try {
    new PerformanceObserver(function (liste) {
      var alle = liste.getEntries();
      lcpWert = alle[alle.length - 1].startTime;
    }).observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (e) { /* Browser kennt LCP nicht */ }

  // --- INP (Reaktion auf Klicks und Tippen) -----------------------------
  // Gemessen wird die langsamste Interaktion des Besuchs. Google bildet bei
  // sehr vielen Interaktionen stattdessen den 98. Perzentilwert; bei einem
  // normalen Shop-Besuch mit wenigen Klicks ist beides dasselbe.
  try {
    new PerformanceObserver(function (liste) {
      liste.getEntries().forEach(function (eintrag) {
        // Nur echte Interaktionen zaehlen (haben eine interactionId)
        if (eintrag.interactionId && eintrag.duration > inpWert) {
          inpWert = eintrag.duration;
        }
      });
    }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
  } catch (e) { /* aeltere Browser kennen event-timing nicht */ }

  // --- FCP (wann der erste Inhalt sichtbar wird) ------------------------
  try {
    new PerformanceObserver(function (liste) {
      liste.getEntries().forEach(function (eintrag) {
        if (eintrag.name === 'first-contentful-paint') fcpWert = eintrag.startTime;
      });
    }).observe({ type: 'paint', buffered: true });
  } catch (e) { /* ignorieren */ }

  // --- Erstbesuch erkennen ----------------------------------------------
  // Beim Erstbesuch sind Schriften und Dateien noch nicht gespeichert.
  // Nur dann tritt der Schrift-Sprung ueberhaupt auf, deshalb ist diese
  // Unterscheidung der eigentliche Zweck der Messung.
  var erstbesuch = 'unbekannt';
  if (MERKER_NUTZEN) {
    try {
      erstbesuch = localStorage.getItem('rm_besucht') ? 'nein' : 'ja';
      localStorage.setItem('rm_besucht', '1');
    } catch (e) { /* privates Fenster o. ae. */ }
  }

  function seitenart() {
    var p = location.pathname;
    if (p === '/' ) return 'startseite';
    if (p.indexOf('/products/') === 0) return 'produkt';
    if (p.indexOf('/collections/') === 0) return 'kategorie';
    if (p.indexOf('/pages/') === 0) return 'seite';
    if (p.indexOf('/cart') === 0) return 'warenkorb';
    if (p.indexOf('/policies/') === 0) return 'rechtliches';
    return 'sonstige';
  }

  function senden() {
    if (gesendet) return;
    gesendet = true;

    // Kein Analytics aktiv (z. B. Cookie-Banner abgelehnt) -> nichts senden.
    if (typeof window.gtag !== 'function') return;

    // Im Hintergrund geoeffnet -> Zeiten waeren verfaelscht, nicht senden.
    if (warVorErstemBildVersteckt()) return;

    try {
      window.gtag('event', 'ladewerte', {
        // CLS mal 1000, weil Analytics mit ganzen Zahlen besser umgeht
        cls_x1000: Math.round(clsWert * 1000),
        lcp_ms: Math.round(lcpWert),
        inp_ms: Math.round(inpWert),
        fcp_ms: Math.round(fcpWert),
        // "Antwortzeit Server": seit 26.09.2026 der Zeitpunkt, zu dem die
        // Seite komplett beim Browser ist (responseEnd). Vorher war es
        // responseStart - das ist bei Shopify irrefuehrend frueh, weil
        // Shopify den Antwort-KOPF sofort schickt (~30 ms), den Inhalt aber
        // erst nach der Berechnung (~400-600 ms). Werte vor und nach dem
        // 26.09. deshalb nicht direkt vergleichen.
        ttfb_ms: (function () {
          try {
            var n = performance.getEntriesByType('navigation')[0];
            return n ? Math.round(n.responseEnd) : 0;
          } catch (e) { return 0; }
        })(),
        seitenart: seitenart(),
        erstbesuch: erstbesuch,
        breite: window.innerWidth
      });
    } catch (e) { /* nie die Seite wegen einer Messung stoeren */ }
  }

  // Senden, wenn der Besucher die Seite verlaesst oder wegwechselt.
  // Erst dann stehen CLS und LCP endgueltig fest.
  addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') senden();
  });
  addEventListener('pagehide', senden);
})();
